<template lang="pug">
    #page-404
        .section.container
            .columns.is-centered
                .column.is-half-fullhd.has-text-centered
                    h1.title 404
                    h3.subtitle Page not found
</template>

<script>
export default {
  name: "Page404"
};
</script>

<style lang="scss" scoped>
#page-404 {
  min-height: calc(100vh - 23.5rem);
  display: flex;
  justify-content: center;
  align-items: center;
  .title,
  .subtitle {
    color: var(--font-color);
  }
}
</style>
